<template>

<div id='fb-conainer'>
    
    <button @click='toggleShow()' id='feedback-button' class="btn btn-socials">
        <span :class='["icon", show ? "icon-cross" : "icon-dialog"]'></span>
    </button>

    <transition name="fade">
    <div id='feedback-form' v-if='show'>
        <div id='feedback-header'>
            {{ model.c ? model.c : 'Feedback' }}
        </div>

        <div v-if='!model.c'>
            <p> What feedback do you have? </p>
            
            <div @click='setCat(c)' v-for='c in cats' class='feedback-cat-btn'>
                {{ c }}
            </div>

        </div>
        <div v-if='model.c' class='mb-4'>
            <div class="row mb-3">
                <div class="col-12 mb-3">
                    <input v-model.trim='model.e' placeholder="Email Address (Optional)" :readonly='isLoading' class="form-control">
                </div>
                <div class="col-12">
                    <textarea @change='checkLen' id='text' v-model.trim='model.t' placeholder="Your feed back - up to 250 characters" rows=6 :readonly='isLoading' class="form-control">
                    </textarea>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-6">
                    <button @click='reset()' class='btn btn-primary btn-white'>
                        Back
                    </button>
                </div>
                <div class="col-6">
                    <button @click='submit()' class='btn btn-primary btn-white' :disabled='isLoading'>
                        Submit
                    </button>
                </div>
            </div>
        </div>

    </div>
    </transition>

</div>


</template>

<script>
    export default {

        mounted() {
            var me = this;

            $(window).click(function() {
                if( me.show ) {
                    me.toggleShow();
                }    
            });

            $('#fb-conainer').click(function(event){
                event.stopPropagation();
            });
        },

        created() {
            this.model = Object.assign( {}, this.mdl );
        },

        data() { 

            return {
                isReady : false,
                isLoading : false,
                show    : false,
                cats    : [
                    'General Feedback',
                    'I have an idea',
                    'I found a bug',
                ],

                mdl : {
                    c : false,
                    e : '',
                    t : ''
                }
            }
            
        },

        methods : {
            setCat(c) {
                this.model.c = c;
                this.$forceUpdate();
            },

            reset(c) {
                this.model = Object.assign({}, this.mdl);
                this.$forceUpdate();
            },

            toggleShow() {
                if( !this.show ) {
                
                    this.show = true;  
                
                } else {

                    this.model = Object.assign({}, this.mdl);
                    this.show = false;
                }
            },

            submit() {
                if( !this.model.t ) {
                    $("#text").focus();
                    $.notify("Please provide more info","warning");
                    return;
                }

                this.isLoading = true;

                this.ajax.call('fb:sbm', this.model, (r) => {
                    
                    if( r.status == 'success' ) {
                        $.notify("Your feedback has been submited.","success");  

                        if( this.show ) {
                            this.toggleShow();
                        } 

                        this.isLoading = false;
                        this.model = Object.assign({}, this.mdl);
                    }

                }, {}, (err) => {

                    this.isLoading = false;

                    if( this.show ) {
                        this.toggleShow();
                    }

                    $.notify("Could not submit your feedback. Please try again later.","warning"); 

                })
            },

            checkLen() {
                if( this.model.t && this.model.t .length > 250 ) {
                    this.model.t = this.model.t.substr(0,250);
                }
            }
        }

    }
</script>
<style>

/*#app #feedback-button {
    border: 1px solid;
    padding: 10px 15px;
    border-radius: 24px;
    position: fixed;
    bottom : 25px;
    right: 25px;
}

#app #feedback-form {
    border: 1px solid;
    z-index: 999;
    background: white;
    padding: 10px 15px;
    position: fixed;
    bottom : 68px;
    right: 68px;
    text-align: center;
    max-width: 280px;
}

#app #feedback-header {
    padding: 10px;
    margin-bottom: 20px;
    background: blue;
    color: white;
    font-weight: bold;
}

#app .feedback-cat-btn {
    padding: 10px;
    margin-bottom: 10px;
    border: 1px solid blue;
    color: blue;
    font-weight: bold;
    cursor: pointer;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}*/

</style>